export const initialRouteState = {
  status: "idle",
  startPort: null,
  currentPort: null,
  ports: [],
  segments: [],
};

export function routeReducer(state, action) {
  switch (action.type) {
    case "START":
      return {
        status: "building",
        startPort: action.portId,
        currentPort: action.portId,
        ports: [{ id: action.portId, days: 0 }],
        segments: [],
      };

    case "ADD_SEGMENT": {
      if (state.status !== "building") return state;
      if (action.connection.from !== state.currentPort) return state;

      const nextPort = action.connection.to;

      const newState = {
        ...state,
        currentPort: nextPort,
        ports: [...state.ports, { id: nextPort, days: 0 }],
        segments: [...state.segments, action.connection],
      };

      if (nextPort === state.startPort) {
        newState.status = "finished";
      }

      if (newState.ports.length > 6) {
        newState.status = "finished";
      }

      return newState;
    }

    case "SET_PORT_DAYS": {
      const { index, days } = action;

      const updatedPorts = state.ports.map((p, i) =>
        i === index ? { ...p, days } : p
      );

      return {
        ...state,
        ports: updatedPorts,
      };
    }

    case "UNDO": {
      if (state.ports.length <= 1) return state;

      const newPorts = state.ports.slice(0, -1);
      const newSegments = state.segments.slice(0, -1);

      return {
        ...state,
        status: "building",
        currentPort: newPorts[newPorts.length - 1].id,
        ports: newPorts,
        segments: newSegments,
      };
    }

    case "FINISH":
      if (state.status !== "building") return state;
      return { ...state, status: "finished" };

    case "RESET":
      return initialRouteState;

    case "SET_BUILDING":
      return {
        ...state,
        status: "building",
        startPort: null,
        currentPort: null,
        ports: [],
        segments: [],
      };

    default:
      return state;
  }
}

export function getAvailableConnections(state, allConnections) {
  if (state.status !== "building") return [];

  return allConnections.filter(conn => {
    if (conn.from !== state.currentPort) return false;

    if (conn.to === state.startPort) return true;

    const lastPort = state.ports[state.ports.length - 2];
    if (lastPort && conn.to === lastPort.id) return false;

    return true;
  });
}